import { ChangeEvent } from 'react';
import AccordionComponent from '../../common/Accordion';
import CustomCheckbox from '../../common/Checkbox';
import RadioGroupComponent from '../../common/RadioGroup';
import { IDiabetesType } from '../../PatrnerAndMembersManagment/types';
import styles from './styles';

export interface IMemberFilterModalProps {
    selectedMemberStatus?: string | number | boolean;
    selectedMemberPeriod?: string | number | boolean;
    diabetesTypeData: IDiabetesType[];
    onMemberStatusChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onMemberPeriodChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onDiabetesTypeChange?: (name: string, checked: boolean) => void;
}

const statusData = [
    {
        value: 'active',
        label: 'Active',
    },
    {
        value: 'inActive',
        label: 'Inactive',
    },
];
const additionPeriodData = [
    {
        value: 'Last7Days',
        label: 'Last 7 Days',
    },
    {
        value: 'Last15Days',
        label: 'Last 15 Days',
    },
    {
        value: 'Last30Days',
        label: 'Last 30 Days',
    },
    {
        value: 'Last90Days',
        label: 'Last 90 Days',
    },
];

const MemberFilterModal = ({
    selectedMemberStatus,
    selectedMemberPeriod,
    onMemberStatusChange,
    onMemberPeriodChange,
    onDiabetesTypeChange,
    diabetesTypeData,
}: IMemberFilterModalProps) => {
    return (
        <AccordionComponent
            data={[
                {
                    summary: 'Status',
                    detailsNode: (
                        <RadioGroupComponent
                            classes={styles.radioGroupLabel}
                            data={statusData}
                            selectedValue={selectedMemberStatus}
                            name="status"
                            onChange={onMemberStatusChange}
                        />
                    ),
                },
                {
                    summary: 'Addition Period',
                    detailsNode: (
                        <RadioGroupComponent
                            classes={styles.radioGroupLabel}
                            data={additionPeriodData}
                            selectedValue={selectedMemberPeriod}
                            name="additional-period"
                            onChange={onMemberPeriodChange}
                        />
                    ),
                },
                {
                    summary: 'Diabetes Type',
                    detailsNode: (
                        <CustomCheckbox
                            classes={styles.radioGroupLabel}
                            data={diabetesTypeData.map((dt) => ({
                                value: dt.value,
                                label: dt.label,
                                checked: dt.checked,
                            }))}
                            name="diabetes-type"
                            onChange={onDiabetesTypeChange}
                        />
                    ),
                },
            ]}
        />
    );
};
export default MemberFilterModal;
